import { render, staticRenderFns } from "./AdminMessagesTable.vue?vue&type=template&id=8fc6238c&scoped=true"
import script from "./AdminMessagesTable.vue?vue&type=script&lang=js"
export * from "./AdminMessagesTable.vue?vue&type=script&lang=js"
import style0 from "./AdminMessagesTable.vue?vue&type=style&index=0&id=8fc6238c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc6238c",
  null
  
)

export default component.exports